import React, { useState } from "react";
import { DPPageWrapper, DPPermissionGate, DPTabs } from "Components/DP";
import { Box } from "@material-ui/core";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { PageNotFound } from "..";
import { HelpText } from "Components/Shared/HelpText/HelpText";
import { CreateOperatingManager } from "./CreateOperatingManager/CreateOperatingManager";
import { OperatingManagersTable } from "./OperatingManagersTable/OperatingManagersTable";
import { EditOperatingManagerDialog } from "./EditOperatingManager/EditOperatingManagerDialog";
import { DPOperatingManager } from "Shared/types/OperatingManager";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";

const RewardsSetup = () => {
  const { rewardsOptions, permissions } = usePartnerConfig();
  const [editManager, setEditManager] = useState<DPOperatingManager | undefined>();

  const onPageLoad = () => {
    AmplitudeProvider.logEvent({
      type: AmplitudeEventType.RewardSetupPageViewed,
    });
  };

  const hidePage =
    !rewardsOptions?.enableRewards ||
    !permissions.canListRewards;

  if (hidePage) {
    return <PageNotFound />;
  }

  return (
    <DPPageWrapper title="REWARD Setup" onPageLoad={onPageLoad}>
      <DPTabs
        labels={["REWARD Setup"]}
        tabIndex={0}
        onChange={() => {}}
      >
        <Box maxWidth="75%">
          <HelpText>
            <b>What is this?</b>
            <br/>
            The REWARD set up is required by admins to select Operating Managers, who will have access to give rewards to employees.
          </HelpText>
        </Box>
        <DPPermissionGate permissionKeys={["canCreateRewardBudgets"]}>
          <CreateOperatingManager />
          <EditOperatingManagerDialog
            isOpen={!!editManager}
            onClose={() => { setEditManager(undefined); }}
            manager={editManager!}
          />
        </DPPermissionGate>
        <OperatingManagersTable onEdit={(manager) => {
          setEditManager(manager);
        }}/>
      </DPTabs>
    </DPPageWrapper>
  );
};

export default RewardsSetup;
